module.exports = __webpack_public_path__ + "img/authorityLogo8.c657bcc2.png";